import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, RefreshCw } from 'lucide-react';

interface UpdateBannerProps {
  onUpdate: () => void;
  onDismiss: () => void;
}

export const UpdateBanner = ({ onUpdate, onDismiss }: UpdateBannerProps) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-300">
      <div className="bg-primary text-primary-foreground shadow-lg border-t border-primary-foreground/10">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 flex-1">
              <RefreshCw className="h-5 w-5 flex-shrink-0" />
              <div className="flex-1">
                <p className="font-semibold text-sm sm:text-base">
                  New version available!
                </p>
                <p className="text-xs sm:text-sm opacity-90">
                  Update now to get the latest features and improvements
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <Button
                variant="secondary"
                size="sm"
                onClick={() => {
                  setIsVisible(false);
                  onDismiss();
                }}
                className="h-8 px-3"
              >
                Later
              </Button>
              <Button
                variant="secondary"
                size="sm"
                onClick={onUpdate}
                className="h-8 px-3 font-semibold"
              >
                Update Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const useUpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  const handleUpdate = () => {
    window.location.reload();
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  const triggerUpdateNotification = () => {
    setShowUpdate(true);
  };

  return {
    showUpdate,
    handleUpdate,
    handleDismiss,
    triggerUpdateNotification,
  };
};
